import type { LockReason } from './types';

export type EnvelopeFailure = 'signature' | 'header' | 'tag' | 'length' | 'file_hash';

export class EnvelopeError extends Error {
  constructor(
    readonly reason: EnvelopeFailure,
    readonly segment?: number,
  ) {
    super(
      segment === undefined
        ? `protected file rejected: ${reason}`
        : `protected file rejected: ${reason} at segment ${segment}`,
    );
    this.name = 'EnvelopeError';
  }
}

export class UnverifiedEnvelopeError extends Error {
  constructor() {
    super('envelope did not come from verifyEnvelope');
    this.name = 'UnverifiedEnvelopeError';
  }
}

export class SignInRequiredError extends Error {
  constructor(options: { cause: unknown }) {
    super('sign-in required: getIdToken failed', options);
    this.name = 'SignInRequiredError';
  }
}

export class KeyRefusedError extends Error {
  constructor(readonly reason: string) {
    super(`key refused: ${reason}`);
    this.name = 'KeyRefusedError';
  }
}

export class KeyServiceUnavailableError extends Error {
  constructor(readonly status?: number) {
    super(status === undefined ? 'key service unreachable' : `key service unavailable (${status})`);
    this.name = 'KeyServiceUnavailableError';
  }
}

export class KeyServiceRequestError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
  ) {
    super(`key service rejected the request (${status} ${code})`);
    this.name = 'KeyServiceRequestError';
  }
}

export class KeyResponseInvalidError extends Error {
  constructor(
    readonly field: string,
    options?: { cause?: unknown },
  ) {
    super(`key service response rejected: ${field}`, options);
    this.name = 'KeyResponseInvalidError';
  }
}

export class NoLauncherError extends Error {
  constructor() {
    super('no launcher window: open the protected file and click Open');
    this.name = 'NoLauncherError';
  }
}

export class DocumentLockedError extends Error {
  constructor(readonly lock: LockReason) {
    super(
      lock.kind === 'refused' ? `document locked: ${lock.reason}` : `document locked: ${lock.kind}`,
    );
    this.name = 'DocumentLockedError';
  }
}
